/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvc3BhY2VzL2NvdW5zZWxvcnMvY291bnNlbG9ycy1zaWRlYmFyL2NvdW5zZWxvcnMtc2lkZWJhci5jb21wb25lbnQuY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBOztHQUVHIiwiZmlsZSI6InNyYy9hcHAvc3BhY2VzL2NvdW5zZWxvcnMvY291bnNlbG9ycy1zaWRlYmFyL2NvdW5zZWxvcnMtc2lkZWJhci5jb21wb25lbnQuY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLyogI2NvdW5zZWxvcnMtc2lkZWJhciB7XG4gICAgYm9yZGVyLXJhZGl1czogMTVweDtcbn0gKi8iXX0= */"];
export { styles as styles };
